// Arrow-paging for the "Delicious Recipes" carousel.

(function () {
    function init() {
        document.querySelectorAll('.home-recipes').forEach(setup);
    }

    function setup(section) {
        const viewport = section.querySelector('[data-recipes-viewport]');
        const prev = section.querySelector('[data-recipes-prev]');
        const next = section.querySelector('[data-recipes-next]');
        if (!viewport) return;

        const update = () => {
            const max = viewport.scrollWidth - viewport.clientWidth - 2;
            if (prev) prev.disabled = viewport.scrollLeft <= 2;
            if (next) next.disabled = viewport.scrollLeft >= max;
        };

        if (prev) prev.addEventListener('click', () => {
            viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', () => {
            viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' });
        });

        viewport.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
